module.exports = __webpack_public_path__ + "img/ContratoHNNacional3.57e7ba72.png";